import styled from "styled-components/macro";

export const StyledErrorTitle = styled.h2`
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;

  color: #575e68;
`;
export const StyledErrorP = styled.p`
  font-size: 21px;
  line-height: 31px;
  text-align: center;

  color: #575e68;
`;
